<template>
  <Layout>
    <app-recibos-cobranza-tabla />
  </Layout>
</template>

<script>
import RecibosCobranzaTabla from "../components/RecibosCobranzaTabla/RecibosCobranzaTabla.vue";

export default {
  components: {
    "app-recibos-cobranza-tabla": RecibosCobranzaTabla
  }
};
</script>
